import { NgModule } from "@angular/core";
import { TextareaFormComponent } from './textarea-form/textarea-form.component';
import { DynamicTextareaComponent } from './dynamic-textarea.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { TextareaDesignComponent } from './textarea-design/textarea-design.component';
import { TextareaResultComponent } from './textarea-result/textarea-result.component';
import { KendoModule } from '../kendo.module';
import { AbwConditionalFormatingModule } from '../@core/abw-conditional-text-formating.module';

@NgModule({
    declarations: [
        TextareaResultComponent,
        TextareaDesignComponent,
        TextareaFormComponent, DynamicTextareaComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        KendoModule,
        AbwConditionalFormatingModule
    ],
    entryComponents: [
        DynamicTextareaComponent
    ]
})
export class TextareaModule {}